module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/V2grC4/tc-custom/9781427859280.jpg?1703878792732",
      "alt": "This image is the cover for the book Sword Princess Amaltea, Volume 3, Sword Princess Amaltea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sword Princess Amaltea, Volume 3, Sword Princess Amaltea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In the finale of this gender-flipped manga adventure, the adventuresome princess must prove herself worthy of the queendom—and her beautiful prince.")])]), _c('p', [_vm._v(" With Princess Amaltea and Prince Ossian’s feelings for one another slowly blooming into something more than just a convenient partnership, the appearance of a powerful challenger from Ossian's past threatens their future together. But Amaltea still has to prove her worthiness as a suitor and heir to the throne of the Grey Mountains queendom in a battle to the death.  ")]), _vm._v(" Has she grown enough to earn Prince Ossian's hand . . . and heart? Can the two of them find a place in a world stacked so unfairly against them? See the action-packed conclusion in Natalia Batista's gender-flipped fantasy manga with fans all around the world! \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natalia Batista\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0